<div class="container-fluid employer_dash onboarding_section">
  <!-- import business starts -->
  <!-- <div *ngIf="!isBusiness" class="parent-container inactive-card pulse" [ngClass]="{'dNone': url != 'dashboard'}" (click)="goToSection('business-inactive')">
    <div class="grid-container">
      <div class="child-container">
        <h3>1.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
          <img src="assets/images/fir-ico.png" class="ico">
      
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'Import Business From GNI' | translate}}</h3>
          <p class="para-txt">{{'Import Business description' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <h3 class="status-txt">{{'Import Business' | translate}}</h3>
          <i class="fa-solid fa-caret-right"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="!isBusiness">
    <div class="col-12">
      <img src="assets/images/arrow.png">
    </div>
  </div> -->
      <!-- <div class="circle red">
                  <div class="icon">
                    <img src="assets/images/brief.png">
                  </div>
                </div> -->

  <!-- <div *ngIf="isBusiness" class="parent-container active-card" [ngClass]="{'dNone': url != 'dashboard'}" (click)="goToSection('business-active')">
    <div class="grid-container">
      <div class="child-container">
        <h3>1.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
          <img src="assets/images/fir-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'Import Business From GNI' | translate}}</h3>
          <p class="para-txt">{{'Import Business description' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <div *ngIf="accountDetails.cnss != 1 && accountDetails.cnamgs != 1" class="edit-btn" (click)="goToLinkBusiness()">
            <h6 class="edit">{{'Edit' | translate}}</h6>
          </div>
          <div class="status-container">
            <div class="icon-container">
              <img src="assets/images/tickwithcircle.png">
            </div>
            <h3>{{'Done' | translate}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- <div class="row arrowicon" *ngIf="isBusiness" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="no-bank">
    </div>
  </div> -->
  <!-- import business ends -->

  <!-- The bank section is hidden for now as it is not required for the current version. It will be added back in the future. -->
  <!-- import bank starts -->
  <!-- <div *ngIf="!isBank" class="parent-container inactive-card pulse" (click)="goToSection('bank-inactive')">
    <div class="grid-container">
      <div class="child-container">
        <h3>1.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
      
          <img src="assets/images/sec-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'Insert your bank, microfinance or payment details (Mobile Money)' | translate}}</h3>
          <p class="para-txt">{{'Add bank description' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <h3 class="status-txt">{{'Add Bank Details'| translate}}</h3>
          <i class="fa-solid fa-caret-right"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="!isBank" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="bank-inactive">
    </div>
  </div>
  <div *ngIf="isBank" class="parent-container active-card" [ngClass]="{'dNone': isBank && url != 'dashboard'}" (click)="goToSection('bank-active')">
    <div class="grid-container">
      <div class="child-container">
        <h3>1.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
  
          <img src="assets/images/sec-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'Insert your bank, microfinance or payment details (Mobile Money)' | translate}}</h3>
          <p class="para-txt">{{'Add bank description' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <div class="edit-btn" (click)="goToSection('bank-active')">
            <h6 class="edit" *ngIf="!accountDetails?.is_cnamgs_cnss">{{'Edit' | translate}}</h6>
      
          </div>
          <div class="status-container">
            <div class="icon-container">
              <img src="assets/images/tickwithcircle.png">
            </div>
            <h3>{{'Done' | translate}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="isBank" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="bank-active">
    </div>
  </div> -->

  <!-- The bank section is hidden for now as it is not required for the current version. It will be added back in the future. -->

  <!-- import bank ends -->
  <!--  CNAMGS starts -->
  <!-- <div *ngIf="accountDetails.cnamgs == 0" class="parent-container inactive-card pulse" (click)="goToSection('cnamgs-inactive')" [ngClass]="{'dNone': url == 'employees' || url == 'cnss-reports'}">
    <div class="grid-container">
      <div class="child-container">
        <h3>3.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
        
          <img src="assets/images/cng-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'Get CNAMGS Approval' | translate}}</h3>
          <p class="para-txt">{{'Get CNAMGS Approval description' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <h3 class="status-txt">{{'Get Approval' | translate}}</h3>
          <i class="fa-solid fa-caret-right"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="accountDetails.cnamgs == 0" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="no-cnamgs">
    </div>
  </div>
  <div *ngIf="accountDetails.cnamgs == 2 " class="parent-container pending-card pulse" [ngClass]="{'dNone': url == 'employees' || url == 'cnss-reports'}">
    <div class="grid-container">
      <div class="child-container">
        <h3>3.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
         
          <img src="assets/images/cng-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'CNAMGS Approval is Pending' | translate}}</h3>
          <p class="para-txt">{{'The information inserted has been sent for verification by the CNAMGS and is awaiting activation' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <a href="#" *ngIf="accountDetails?.cnamgs_url" (click)="cnamgsPdf($event)" target="_blank" >
            <div class="pdf_icon"><img src="assets/images/cnamgspdf.png"></div>
          </a>
          <div class="status-container">
            <div class="icon-container">
              <img src="assets/images/pend.png">
            </div>
            <h3 class="status-txt">{{'Pending' | translate}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="accountDetails.cnamgs == 2" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="cnamgs-pending">
    </div>
  </div>
  <div *ngIf="accountDetails.cnamgs == 1" class="parent-container active-card cnamgs_card" [ngClass]="{'dNone': url == 'employees' || url == 'cnss-reports' || isCnamgs && url=='cnamgs-report'}">
    <div class="grid-container">
      <div class="child-container">
        <h3>3.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
         
          <img src="assets/images/cng-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'The activation request has been approved by the CNAMGS' | translate}}</h3>
        </div>
      </div>
      <div class="child-container" [ngClass]="{'justify-content-end': !accountDetails?.cnamgs_url}">
        <a href="#" (click)="cnamgsPdf($event)" target="_blank" *ngIf="accountDetails?.cnamgs_url">
          <div class="pdf_icon"><img src="assets/images/cnamgspdf.png"></div>
        </a>
        <div class="status-container">
          <div class="icon-container">
            <img src="assets/images/tickwithcircle.png">
          </div>
          <h3>{{'Done' | translate}}</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="accountDetails.cnamgs == 1" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="cnamgs-approved">
    </div>
  </div> -->
  <!-- <div *ngIf="accountDetails.cnamgs == 3 " class="parent-container rejected-card pulse" (click)="goToSection('cnamgs-inactive')" [ngClass]="{'dNone': (url === 'employees' || url == 'cnss-reports') || isCnamgs && url=='cnamgs-reports'} ">
    <div class="grid-container">
      <div class="child-container">
        <h3>3.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
        
          <img src="assets/images/cng-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'CNAMGS Approval is Rejected' | translate}}</h3>
          <p class="para-txt">{{'Get CNAMGS Approval description' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <a href="#" (click)="cnamgsPdf($event)" target="_blank" *ngIf="accountDetails?.cnamgs_url">
          <div class="pdf_icon"><img src="assets/images/cnamgspdf.png"></div>
        </a>
        <div class="status-container">
          <div class="icon-container">
            <img src="assets/images/rej.png">
          </div>
          <h3 class="status-txt">{{'Resubmit' | translate}}</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="accountDetails.cnamgs == 3" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="cnamgs-rejected">
    </div>
  </div> -->
  <!--  CNAMGS ends -->
  <!--  CNSS starts -->
  <!-- <div *ngIf="accountDetails.cnss == 0 " class="parent-container inactive-card pulse" [ngClass]="{'dNone': url == 'employees' || url == 'cnamgs-report'}" (click)="goToSection('cnss-inactive')">
    <div class="grid-container">
      <div class="child-container">
        <h3>4.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
        
          <img src="assets/images/cnss-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'Get CNSS Approval' | translate}}</h3>
          <p class="para-txt">{{'Get CNSS Approval description' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <h3 class="status-txt">{{'Get Approval' | translate}}</h3>
          <i class="fa-solid fa-caret-right"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="accountDetails.cnss == 0" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="no-cnss">
    </div>
  </div>
  <div *ngIf="accountDetails.cnss == 2 " class="parent-container pending-card pulse" [ngClass]="{'dNone': url == 'employees' || url == 'cnamgs-report'}">
    <div class="grid-container">
      <div class="child-container">
        <h3>4.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
       
          <img src="assets/images/cnss-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'CNSS Approval is Pending' | translate}}</h3>
          <p class="para-txt">{{'The information inserted has been sent for verification by the CNSS and is awaiting activation' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <a href="#" (click)="cnssPdf($event)" target="_blank" *ngIf="!accountDetails?.is_cnss">
            <div class="pdf_icon"><img src="assets/images/cnsspdf.png"></div>
          </a>
          <div class="status-container">
            <div class="icon-container">
              <img src="assets/images/pend.png">
            </div>
            <h3 class="status-txt">{{'Pending' | translate}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="accountDetails.cnss == 2" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="cnss-pending">
    </div>
  </div>
  <div *ngIf="accountDetails.cnss == 1 " class="parent-container active-card cnss_card" [ngClass]="{'dNone': (url === 'employees' || url == 'cnamgs-report') || isCnss && url=='cnss-reports'} ">
    <div class="grid-container">
      <div class="child-container">
        <h3>4.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
         
          <img src="assets/images/cnss-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'The activation request has been approved by the CNSS' | translate}}</h3>
        </div>
      </div>
      <div class="child-container" [ngClass]="{'justify-content-end': accountDetails?.is_cnss}">
        <a href="#" (click)="cnssPdf($event)" target="_blank" *ngIf="!accountDetails?.is_cnss">
          <div class="pdf_icon"><img src="assets/images/cnsspdf.png"></div>
        </a>
        <div class="status-container">
          <div class="icon-container">
            <img src="assets/images/tickwithcircle.png">
          </div>
          <h3>{{'Done' | translate}}</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="accountDetails.cnss == 1" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="cnss-approved">
    </div>
  </div>
  <div *ngIf="accountDetails.cnss == 3" class="parent-container rejected-card pulse" (click)="goToSection('cnss-inactive')" [ngClass]="{'dNone': (url === 'employees' || url == 'cnamgs-report') || isCnss && url=='cnss-reports'} ">
    <div class="grid-container">
      <div class="child-container">
        <h3>4.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
         
          <img src="assets/images/cnss-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'CNSS Approval is Rejected' | translate}}</h3>
          <p class="para-txt">{{'Get CNSS Approval description' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <a href="#" (click)="cnssPdf($event)" target="_blank" *ngIf="!accountDetails?.is_cnss">
          <div class="pdf_icon"><img src="assets/images/cnsspdf.png"></div>
        </a>
        <div class="status-container">
          <div class="icon-container">
            <img src="assets/images/rej.png">
          </div>
          <h3 class="status-txt">{{'Resubmit' | translate}}</h3>
        </div>
      </div>
    </div>
  </div>
  <div class="row arrowicon" *ngIf="accountDetails.cnss == 3" [ngClass]="{'dNone': url != 'dashboard'}">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="cnss-rejected">
    </div>
  </div> -->

<!-- The employee section is hidden for now as it is not required for the current version. It will be added back in the future. -->

  <!-- <div *ngIf="accountDetails.EmployeeDetails == 0" class="parent-container inactive-card pulse" [ngClass]="{'dNone': (url === 'cnss-reports' || url === 'cnamgs-report') || (isEmployees && url =='employees') || (isBank && url =='employees') }" (click)="goToSection('add-Employee-inactive')">
    <div class="grid-container">
      <div class="child-container">
        <h3>2.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
          <img src="assets/images/las-ico.png" class="ico">
      
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'Add Employee Details' | translate}}</h3>
          <p class="para-txt">{{'Add Employee Description' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <h3 class="status-txt">{{'Add Employee' | translate}}</h3>
          <i class="fa-solid fa-caret-right"></i>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="accountDetails.EmployeeDetails == 1" class="parent-container active-card" [ngClass]="{'dNone': (url === 'cnss-reports' || url === 'cnamgs-report') || (isEmployees && url =='employees' )}" (click)="showModal()">
    <div class="grid-container">
      <div class="child-container">
        <h3>2.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
          <img src="assets/images/las-ico.png" class="ico">
        
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'Add Employee Details' | translate}}</h3>
          <p class="para-txt">{{'Add Employee Description' | translate}}</p>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <div class="icon-container">
            <img src="assets/images/tickwithcircle.png">
          </div>
          <h3>{{'Done' | translate}}</h3>
        </div>
      </div>
    </div>
  </div> -->

<!-- The employee section is hidden for now as it is not required for the current version. It will be added back in the future. -->


  <!-- add employee ends -->
<!--   <div class="row arrowicon" *ngIf="accountDetails.cnss == 1 && accountDetails.EmployeeDetails == 1" alt="no-employee">
    <div class="col-12">
      <img src="assets/images/arrow.png">
    </div>
  </div>
  <div *ngIf="accountDetails.cnss == 1 && accountDetails.EmployeeDetails == 1" class="parent-container inactive-card cnss_card" [ngClass]="{'dNone': (url === 'employees' || url == 'cnamgs-report') || isCnss && url=='cnss-reports'}" (click)="goToSection('cnamgs-reportlist')">
    <div class="grid-container">
      <div class="child-container">
        <h3>6.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
          <img src="assets/images/cng-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'Initiate CNAMGS DTS Quarterly declaration' | translate}}</h3>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <h3 class="status-txt">{{'Generate Report' | translate}}</h3>
          <i class="fa-solid fa-caret-right"></i>
        </div>
      </div>
    </div>
  </div> -->
<!--   <div class="row arrowicon" *ngIf="accountDetails.cnamgs == 1 && accountDetails.EmployeeDetails == 1">
    <div class="col-12">
      <img src="assets/images/arrow.png" alt="initiate-report-cnamgs">
    </div>
  </div>
  <div *ngIf="accountDetails.cnamgs == 1 && accountDetails.EmployeeDetails == 1" class="parent-container inactive-card cnamgs_card" [ngClass]="{'dNone': url == 'employees' || url == 'cnss-reports' || isCnamgs && url=='cnamgs-report'}" (click)="goToSection('cnss-reportlist')">
    <div class="grid-container">
      <div class="child-container">
        <h3>7.</h3>
      </div>
      <div class="child-container">
        <div class="icon-container">
          <img src="assets/images/cnss-ico.png" class="ico">
        </div>
      </div>
      <div class="child-container">
        <div class="text-container">
          <h3>{{'Initiate CNSS DTS Quarterly declaration' | translate}}</h3>
        </div>
      </div>
      <div class="child-container">
        <div class="status-container">
          <h3 class="status-txt">{{'Generate Report' | translate}}</h3>
          <i class="fa-solid fa-caret-right"></i>
        </div>
      </div>
    </div>
  </div> -->
</div>
<section class="modal-section2 bulk-upload-modal getstarted">
  <div class="modal fade" id="onBoarding_modal" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="parent">
            <div class="image-container">
              <img src="assets/images/link_success.png">
            </div>
            <div class="text-container text-center mt-5">
              <h4 class="modal-header-txt">{{'Inorder to Continue' | translate}}</h4>
              <p class="para-light">{{'You must first validate the previous step before proceeding to this step.' | translate }}</p>
            </div>
            <div class="button-container justify-content-center mt-4 d-flex">
              <button type="submit" id="submit_btn" class="btn btn-medium" (click)="closeModal1()">{{'OK' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="modal-section2 bulk-upload-modal getstarted">
  <div class="modal fade" id="employeeSuccessModal" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="parent">
            <div class="image-container">
              <img src="assets/images/link_success.png">
            </div>
            <div class="text-container d-flex text-center mt-5 justify-content-center">
              <div class="child-container">
                <h4 class="modal-header-txt">{{'Employees' | translate}}</h4>
                <p class="para-light">{{'CCPS identifier2' | translate }}</p>
                <p class="para-light">{{'CCPS identifier' | translate }}</p>
              </div>
            </div>
            <div class="button-container justify-content-center mt-4 d-flex">
              <button type="submit" id="submit_btn" class="btn btn-medium" data-dismiss="modal">{{'OK' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="modal-section2 bulk-upload-modal getstarted">
  <div class="modal fade" id="addEmployeeConfirmModal" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="parent">
            <div class="image-container">
              <img src="assets/images/Link-sucsess.png">
            </div>
            <div class="text-container d-flex text-center mt-5 justify-content-center">
              <div class="child-container" *ngIf="accountDetails.cnamgs != 1 || accountDetails.cnss != 1">
                <h4 class="modal-header-txt">{{'Employees' | translate}}</h4>
                <p class="para-light">{{'addEmployeeRules1' | translate }} <br>{{'addEmployeeRules2' | translate }} <br>{{'addEmployeeRules2new' | translate }}</p>
              </div>
              <div class="child-container" *ngIf="accountDetails.cnamgs == 1 && accountDetails.cnss == 1 && accountDetails.EmployeeDetails == 0">
                <h4 class="modal-header-txt">{{'Employees' | translate}}</h4>
                <p class="para-light">{{'addEmployeeRules3' | translate }} 
              </div>
            </div>
            <div class="button-container justify-content-center mt-4 d-flex">
              <button type="submit" id="submit_btn" class="btn btn-medium" (click)="goToSection('add-employee-modal')">{{'OK' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
